import { render } from "./occupancySelect.vue?vue&type=template&id=23a3d3b1&scoped=true"
import script from "./occupancySelect.vue?vue&type=script&lang=js"
export * from "./occupancySelect.vue?vue&type=script&lang=js"

import "./occupancySelect.vue?vue&type=style&index=0&id=23a3d3b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a3d3b1"]])

export default __exports__